<template>
  <v-dialog v-model="localValue" width="500" persistent>
    <v-card>
      <v-card-title>Please Note</v-card-title>
      <v-card-text>
        Please note that selecting another feed type will de-select the feed
        source
      </v-card-text>
      <v-card-actions>
        <v-btn @click="handleOk" style="margin-left: auto;" color="primary">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "FeedTypeReminderDialog",
  props: {
    value: {
      // for v-model binding in parent
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      localValue: this.value
    };
  },
  watch: {
    value(val) {
      this.localValue = val;
    },
    localValue(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    handleOk() {
      this.$emit("ok");
      this.localValue = false;
    }
  }
};
</script>
